import Cookies from 'js-cookie'
import jstz from 'jstz';

(function( app, BrowserTZone, $, undefined ) {
  'use strict';
  // Public Method
  BrowserTZone.setCookie = function() {
    Cookies.set("browser.timezone", jstz.determine().name(), { expires: 365, path: '/' })
  }

}( window.app ||= {}, 
  window.app.BrowserTZone ||= {}, 
  jQuery 
));


(function ($) {
  $(function() {
    app.BrowserTZone.setCookie()
  })
})(jQuery);
